import { useQuery } from "@tanstack/react-query";
import { supabase } from '@/lib/supabase/client';
import { useActiveProject } from "@/hooks/useActiveProject";

export interface SkillScores {
  conclusion: number;
  accueil: number;
  empathie: number;
  resolution: number;
  procedure: number;
}

interface UseSkillScoresProps {
  projectId?: number | null;
  startDate?: Date | null;
  endDate?: Date | null;
}

export const useSkillScores = ({ projectId = null, startDate = null, endDate = null }: UseSkillScoresProps = {}) => {
  const { activeProjectId } = useActiveProject();
  const finalProjectId = projectId ?? activeProjectId;
  const startDateIso = startDate?.toISOString() ?? null;
  const endDateIso = endDate?.toISOString() ?? null;

  return useQuery({
    queryKey: ["skill-scores", finalProjectId, startDateIso, endDateIso],
    queryFn: async (): Promise<SkillScores> => {
      const { data, error } = await supabase
        .rpc('fetch_skill_scores', {
          p_project_id: finalProjectId,
          p_start_date: startDateIso,
          p_end_date: endDateIso
        });

      if (error) {
        console.error("Erreur lors de la récupération des scores de compétence:", error);
        throw error;
      }

      return data as SkillScores;
    },
    enabled: finalProjectId !== null,
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};
